import React, { Component } from "react";
import { FiSearch , FiLayers , FiPhoneIncoming , FiCheckCircle } from "react-icons/fi";

const ServiceList = [
    {
        icon: <FiSearch />,
        title: 'Realize sua busca',
        description: 'Você informa o que está procurando, o seguimento e a marca do veículo.'
    },
    {
        icon: <FiLayers />,
        title: 'Iremos realizar para você os melhores contatos',
        description: 'Procuramos em nossa base os melhores fornecedores para sua solicitação.'
    },
    {
        icon: <FiPhoneIncoming />,
        title: 'Deixe seu contato',
        description: 'Informe os seus melhores contatos para que os fornecedores entrem em contato.'
    },
    {
        icon: <FiCheckCircle />,
        title: 'Escolha o melhor preço',
        description: 'Análise entre os fornecedores e escolha.'
    }
]

class ServiceTwo extends Component{
    render(){
        let title = 'Como Funciona?',
        description = 'Com simples etapas, você verá que é possível encontrar de forma barata o que você está precisando.';
        return(
            <React.Fragment>
                <div className="row">
                    <div className="col-lg-4 col-12">
                        <div className="section-title mt--30 mt_md--5 mt_mobile--5 mb_mobile--10">
                            <h2 className="title">{title}</h2>
                            <p>{description}</p>
                            <div className="service-btn">
                                <a className="btn-transparent rn-btn-dark" href="/"><span className="text">Realize sua consulta</span></a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8 col-12 mt_md--50">
                        <div className="row service-one-wrapper">
                            {ServiceList.map( (val , i) => (
                                <div className="col-lg-6 col-md-6 col-sm-6 col-12" key={i}>
                                    <a href="/">
                                        <div className="service service__style--2">
                                            <div className="icon">
                                                {val.icon}
                                            </div>
                                            <div className="content">
                                                <h3 className="title">{val.title}</h3>
                                                <p>{val.description}</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceTwo;
